import { StyledComponent } from "@emotion/styled";
import { styled } from "@mui/material/styles";
import { getNestedThemeColor } from "../../utils/getNestedThemeColor";
import { Badge, BadgeProps, Chip, ChipProps } from "../materialUI";

interface StyledBadgeProps extends BadgeProps {
  customColor: string;
  isOutlined?: boolean;
}

export const StyledBadge: StyledComponent<StyledBadgeProps> = styled(Badge, {
  shouldForwardProp: (prop) => prop !== "customColor" && prop !== "isOutlined",
})<StyledBadgeProps>(({ theme, customColor, isOutlined, badgeContent }) => {
  const nestedColor = getNestedThemeColor(theme, customColor);
  const isIcon = typeof badgeContent !== "string";
  return {
    "& .MuiBadge-badge": {
      backgroundColor: isOutlined || isIcon ? "transparent" : nestedColor,
      color: isOutlined || isIcon ? nestedColor : "white",
      whiteSpace: "nowrap",
      border: isOutlined ? `1px solid ${nestedColor}` : "none",
    },
  };
});

interface StyledChipProps extends ChipProps {
  customColor: string;
}

export const StyledChip: StyledComponent<StyledChipProps> = styled(Chip, {
  shouldForwardProp: (prop) => prop !== "customColor",
})<StyledChipProps>(({ theme, customColor }) => {
  const nestedColor = getNestedThemeColor(theme, customColor);

  return {
    "&.MuiChip-filled": {
      backgroundColor: nestedColor,
      color: "white",
      whiteSpace: "nowrap",
    },
    "&.MuiChip-outlined": {
      backgroundColor: "transparent",
      color: nestedColor,
      whiteSpace: "nowrap",
      border: `1px solid ${nestedColor}`,
    },
  };
});
